import type { FC } from 'react';
import { useRecoilValue } from 'recoil';
import LandingPage from '@/pages/LandingPage';
import { loginSelector } from '@/store';

const Auth: FC = () => {
  const isLogin = useRecoilValue(loginSelector);
  if (!isLogin) {
    window.location.replace(import.meta.env.VITE_PPN_LOGIN_URL);
  }

  return <LandingPage />;
};
export default Auth;
